import { useState, useEffect, Fragment } from 'react';
import dF from 'dateformat';
import { addYears } from 'date-fns';
import _ from 'lodash';

//Redux
import { StateModel, actions } from 'store/store';
import { useSelector, useDispatch } from 'react-redux';

//Components
import Input from 'components/input/Input';
import Button from 'components/button/Button';
import { Table } from 'rsuite';
import { CSVLink } from 'react-csv';

//Helpers
import { tableHeaders } from './quotes.utilities';
import { QuotesModel } from 'store/quotes/quotesStateModel';

//Styles
import './quotes.scss';
import 'rsuite/dist/styles/rsuite-default.css';




const Quotes = () => {
    const dispatch = useDispatch();
    const [mpan, setMpan] = useState("2380001907849");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [file, setFile] = useState<File>(null);
    const [allQuotes, setAllQuotes] = useState<QuotesModel[]>([]);
    const [page, setPage] = useState(1);
    const [displayLength, setDisplayLength] = useState(20);
    const [sortColumn, setSortColumn] = useState("");
    const [sortType, setSortType] = useState(null);


    const { HeaderCell, Column, Cell, Pagination } = Table;

    //Selectors
    const loading = useSelector((state: StateModel) => state.quotesState.fetchingQuotes);
    const quotes = useSelector((state: StateModel) => state.quotesState.quotes);

    const onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setFile(e.target.files[0]);
        }
    };

    const buildQuotes = () => {
        dispatch(actions.quotes.buildQuotesAsync(mpan, file, dF(startDate, "yyyy-mm-dd"), dF(endDate, "yyyy-mm-dd")));
    }

    const handleChangePage = (dataKey) => {
        setPage(dataKey);   
    }

    const handleChangeLength = (dataKey) => {
        setPage(1);
        setDisplayLength(dataKey);
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
    }


    useEffect(() => {
        if (quotes) {
            const paginated = quotes.filter((quote, index) => {
                const start = displayLength * (page - 1);
                const end = start + displayLength;

                return index >= start && index < end;
            });

            const sorted = _.orderBy(paginated, [sortColumn], [sortType]);

            setAllQuotes(sorted);
        }
        // setStartDate("2022-06-16");
        // setEndDate("2024-06-19");
    }, [quotes, displayLength, page, sortType, sortColumn]);

    return (
        <div className="quotes">
            <div className="content">
                {!allQuotes.length && (
                    <Fragment>
                        <p>Build a quote using metering data and non-commodity costs</p>
                        <Input 
                            inputLabel="Mpan"
                            inputValue={mpan}
                            onChange={(e) => setMpan(e.target.value)}
                        />
                        <Input 
                            inputLabel="Start Date"
                            isDate
                            minDate={addYears(new Date(), -6)}
                            maxDate={addYears(new Date(), 6)}
                            inputValue={startDate ? dF(startDate, "yyyy-mm-dd") : ""}
                            selectedDate={(date) => {
                                setStartDate(date);
                                setEndDate(null);
                            }}
                        />
                        <Input 
                            inputLabel="End Date"
                            isDate
                            inputValue={endDate ? dF(endDate, "yyyy-mm-dd") : ""}
                            startDate={startDate}
                            minDate={startDate}
                            maxDate={addYears(startDate, 10)}
                            selectedDate={(date) => setEndDate(date)}
                        />
                        <div className="file">
                            <div className="name">{file ? file.name : ''}</div>
                            <label className="choose">
                                <span>upload LOA</span>
                                <input
                                    type="file"
                                    onChange={onSelectFile}
                                    accept="application/pdf, application/vnd.ms-excel"
                                />
                            </label>
                        </div>
                        <div className="actions">
                            <Button 
                                text="submit" 
                                loadingText="fetching-quotes" 
                                isLoading={loading} 
                                disabled={!mpan || !startDate || !endDate || !file}
                                onClick={buildQuotes} 
                            />
                            <span className="cancel" onClick={() => setAllQuotes([])}>Cancel</span>
                        </div>
                    </Fragment>
                )}

                {(allQuotes.length > 0) && (
                    <div className="table-container">
                        <div className="export">
                            <Button text="Back" onClick={() => setAllQuotes([])} />
                            <CSVLink data={quotes} headers={tableHeaders.map(t => { return { label: t.headerName, key: t.field } })}>Export</CSVLink>
                        </div>
                        <Table
                            height={1000}
                            width={1500}
                            bordered
                            cellBordered
                            sortColumn={sortColumn}
                            sortType={sortType}
                            onSortColumn={handleSortColumn}
                            data={allQuotes}
                            loading={loading}
                        >
                            {tableHeaders.map((header, index) => (
                                <Column key={index} width={200} sortable={header.sortable}>
                                    <HeaderCell>{header.headerName}</HeaderCell>
                                    <Cell dataKey={header.field} />
                                </Column>
                            ))}
                        </Table>
                        <Pagination 
                            lengthMenu={[
                                {
                                value: 10,
                                label: 10
                                },
                                {
                                value: 20,
                                label: 20
                                }
                            ]}
                            activePage={page}
                            displayLength={displayLength}
                            total={quotes ? quotes.length : null}
                            onChangePage={handleChangePage}
                            onChangeLength={handleChangeLength}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}




export default Quotes;